import { render, staticRenderFns } from "./CloudinaryImageEditor.vue?vue&type=template&id=67a2fcc3&scoped=true&"
import script from "./CloudinaryImageEditor.vue?vue&type=script&lang=js&"
export * from "./CloudinaryImageEditor.vue?vue&type=script&lang=js&"
import style0 from "./CloudinaryImageEditor.vue?vue&type=style&index=0&id=67a2fcc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a2fcc3",
  null
  
)

export default component.exports